/**
 * All storage backends store the
 */
export class AbstractStaticPartVersionStorageAdapter {
}
//# sourceMappingURL=AbstractStaticPartVersionStorageAdapter.js.map